import { PageContainer, PageContent, ContentTitle } from "@/components/page";
import { useClientAreasDataProvider } from "./client-areas.data-loader";
import { t } from "i18next";
import AreaDataLoader from "../area-aggregate/components/area-data-loader";
import AreaStateAggregate from "../area-aggregate/components/aggregate/area-state-aggregate";
import tw from "twin.macro";

const ClientAreasComponent = () => {
  const { areas } = useClientAreasDataProvider();

  return (
    <PageContainer>
      <PageContent style={{ backgroundColor: "#FBF8F4" }}>
        {/* Titre sticky : reste collé en haut du conteneur de scroll de la
            Layout, les cartes parcelles passent dessous. `-mx-4 px-4` étire
            le fond crème sur toute la largeur (au-delà du padding du
            PageContainer) pour que le contenu qui défile derrière soit
            entièrement masqué. `z-10` le met au-dessus des cartes. */}
        <div
          css={[
            tw`sticky top-0 z-10 -mx-4 px-4 py-3`,
            tw`bg-[#FBF8F4]`,
            tw`flex justify-between gap-2`,
          ]}
        >
          <ContentTitle css={[tw`text-[#625d5d]`]}>
            {t("areas.allAreas")} 🍇
          </ContentTitle>
        </div>

        {areas.length > 0 ? (
          areas.map((area) => {
            return (
              <AreaDataLoader
                key={area._id}
                areaId={area._id}
                numberOfModulesInArea={
                  area.posts.filter((post) => !post.underMaintenance).length
                }
                areaName={area.name}
              >
                <AreaStateAggregate />
              </AreaDataLoader>
            );
          })
        ) : (
          <div tw="flex justify-center w-full">
            <p>{t("areas.noAreas")}</p>
          </div>
        )}
      </PageContent>
    </PageContainer>
  );
};

export default ClientAreasComponent;
